import React from 'react';
import { MapPin, Instagram, Phone, Scissors } from 'lucide-react';
export function Footer() {
  return <footer id="contacto" className="bg-zinc-950 pt-20 pb-10 border-t border-zinc-900" data-id="element-81">
      <div className="container mx-auto px-6" data-id="element-82">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16" data-id="element-83">
          {/* Brand */}
          <div data-id="element-84">
            <h3 className="font-brush text-4xl mb-4 text-zinc-100 drop-shadow-[0_0_14px_rgba(220,38,38,0.35)]" data-id="element-85">
              Okrim
            </h3>
            <p className="text-zinc-400 mb-6 max-w-sm font-light leading-relaxed" data-id="element-86">
              Cortes que elevan tu imagen. La mejor experiencia de barbería
              clásica y moderna en el corazón de Montevideo.
            </p>
            <div className="flex gap-4" data-id="element-87">
              <a href="https://instagram.com/okrim_barber" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-zinc-900 flex items-center justify-center text-zinc-400 hover:bg-red-600 hover:text-zinc-50 transition-colors" data-id="element-88">
                <Instagram size={18} data-id="element-89" />
              </a>
              <a href="https://wa.me/59892738664" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-zinc-900 flex items-center justify-center text-zinc-400 hover:bg-red-600 hover:text-zinc-50 transition-colors" data-id="element-90">
                <Phone size={18} data-id="element-91" />
              </a>
            </div>
          </div>

          {/* Contact */}
          <div data-id="element-92">
            <h4 className="font-display text-sm font-bold uppercase tracking-[0.25em] text-red-500 mb-6" data-id="element-93">
              Contacto
            </h4>
            <ul className="space-y-4" data-id="element-94">
              <li className="flex items-start gap-3 text-zinc-400" data-id="element-95">
                <MapPin size={20} className="text-red-500 shrink-0 mt-0.5" data-id="element-96" />
                <span data-id="element-97">
                  Centro, Montevideo
                  <br data-id="element-98" />
                  Uruguay
                </span>
              </li>
              <li className="flex items-center gap-3 text-zinc-400" data-id="element-99">
                <Phone size={20} className="text-red-500 shrink-0" data-id="element-100" />
                <span data-id="element-101">+598 92 738 664</span>
              </li>
            </ul>
          </div>

          {/* CTA */}
          <div data-id="element-102">
            <h4 className="font-display text-sm font-bold uppercase tracking-[0.25em] text-red-500 mb-6" data-id="element-103">
              Reservas
            </h4>
            <p className="text-zinc-400 mb-6 font-light" data-id="element-104">
              Asegurá tu lugar. Agendá tu turno online de forma rápida y
              sencilla.
            </p>
            <button onClick={() => window.open('https://wa.me/59892738664?text=Hola%20Okrim!%20Quería%20agendar%20un%20turno.', '_blank')} className="group relative w-full px-10 py-5 bg-red-600 text-zinc-50 font-display uppercase tracking-widest text-sm font-bold overflow-hidden transition-all hover:scale-105 active:scale-95 shadow-[0_0_40px_rgba(220,38,38,0.25)] hover:shadow-[0_0_60px_rgba(220,38,38,0.4)]" data-id="element-105">
              {/* Barber stripe hover effect */}
              <div className="absolute inset-0 barber-stripe opacity-0 group-hover:opacity-10 transition-opacity duration-500" data-id="element-106"></div>
              <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out" data-id="element-107"></div>
              <span className="relative flex items-center justify-center gap-3" data-id="element-108">
                Agendar por WhatsApp
                <Scissors size={16} data-id="element-109" />
              </span>
            </button>
          </div>
        </div>

        <div className="pt-8 border-t border-zinc-900 grid grid-cols-1 md:grid-cols-3 items-center gap-6 text-sm text-zinc-600" data-id="element-110">
          <p className="text-center md:text-left order-2 md:order-1" data-id="element-111">
            © {new Date().getFullYear()} Okrim Barber. Todos los derechos
            reservados.
          </p>

          <div className="order-1 md:order-2 flex justify-center" data-id="element-112">
            <a href="https://wa.me/59892738664" target="_blank" rel="noreferrer" className="group inline-flex items-center gap-2.5 px-5 py-2.5 rounded-full bg-zinc-900 border border-red-500/30 hover:border-red-500/70 shadow-[0_0_20px_rgba(220,38,38,0.15)] hover:shadow-[0_0_28px_rgba(220,38,38,0.35)] transition-all duration-300" data-id="element-113">
              <span className="text-[10px] font-display uppercase tracking-[0.2em] text-zinc-500" data-id="element-114">
                Desarrollado por
              </span>
              <span className="font-display text-sm font-bold uppercase tracking-wider text-red-500 group-hover:text-red-400 transition-colors drop-shadow-[0_0_8px_rgba(220,38,38,0.5)]" data-id="element-115">
                WEBSITEIA
              </span>
            </a>
          </div>

          <span className="hidden md:block order-3" data-id="element-116" />
        </div>
      </div>
    </footer>;
}